import { Helmet } from 'react-helmet';
import CreateWithAI from './CreateWithAI/CreateWithAI';
import HeadBanner from './HeadBanner/HeadBanner';
import Join from './Join/Join';
import Logistics from './Logistics/Logistics';
import Magnati from './Magnati/Magnati';
import './Main.css';
import MainNav from './MainNav/MainNav';
import Marketing from './Marketing/Marketing';
import MobileFirst from './MobileFirst/MobileFirst';
import Operates from './Operates/Operates';
import Reviews from './Reviews/Reviews';
import SayAboutUs from './SayAboutUs/SayAboutUs';
import Steps from './Steps/Steps';
import Store from './Store/Store';
import {useContext, useEffect} from 'react';
import { TranslationContext } from '../../assets/contexts/translationContext';
import {productIdStorageKey} from "../../assets/utils/constants";

function Main({ theme, onSignupOpen, onEmailChange, email, emailValidity, language, setIsPblPageSignUp, lang, sitePreloaderVisible }) {
    const { helmet } = useContext(TranslationContext);

    useEffect(() => {
      setIsPblPageSignUp(false);
    }, [])

    return (
        <div className='main'>
            <Helmet>
                <title>{helmet.main?.title}</title>
                <meta name="description" content={helmet.main.desc} />
            </Helmet>
            <HeadBanner {...{ onSignupOpen, onEmailChange, email, emailValidity }} sitePreloaderVisible={sitePreloaderVisible} />
            <Reviews theme={theme} />
            <Steps />
            <MobileFirst />
            <Store {...{ onSignupOpen }} />
            <CreateWithAI {...{ onSignupOpen, onEmailChange, email, emailValidity }} theme={theme} />
            <Operates />
            <Magnati theme={theme} language={language} lang={lang} />
            <Join />
            <SayAboutUs />
            <Logistics />
            <Marketing />
            <MainNav {...{ onSignupOpen }} />
        </div>
    );
}

export default Main